import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ConfigService } from '@orion-platform/core';
import { environment } from '@orion/environment';
import { Observable } from 'rxjs';
import { SVNotes, SVNotesResult } from '../models/sv-notes.model';
import { generateHttpParams, getUrl } from '../utils/general.utils';

@Injectable({
  providedIn: 'root',
})
export class SupplyVisibilityNotesService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);

  private readonly baseUrl = this.config.getSettings('apiBaseUrl') as string;
  private readonly mm = environment.modulesBaseUrl.materialManagement;

  getSVNotesByRecord(
    modul: string,
    key: string,
    searchText?: string,
    top?: number,
    skip?: number,
  ): Observable<SVNotesResult> {
    const url = getUrl(this.baseUrl, this.mm.getNotesByRecord);

    const params = generateHttpParams({
      $skip: skip ?? undefined,
      $top: top ?? undefined,
      key: key.toUpperCase(),
      modul,
      searchText: searchText ?? undefined,
    });

    return this.http.get<SVNotesResult>(url, { params });
  }

  createSVNote(data: SVNotes): Observable<SVNotes> {
    const url = getUrl(this.baseUrl, this.mm.createSVNote);
    return this.http.post<SVNotes>(url, data);
  }

  updateSVNote(data: SVNotes): Observable<SVNotes> {
    const url = getUrl(this.baseUrl, this.mm.updateSVNote);
    return this.http.post<SVNotes>(url, data);
  }

  deleteSVNote(data: SVNotes): Observable<SVNotes> {
    const url = getUrl(this.baseUrl, this.mm.deleteSVNote);
    return this.http.delete<SVNotes>(`${url}/${data.id}`);
  }
}
